// @flow
import React, { Component } from 'react';
import CrossIcon from 'mz-icons/cross';
import { Container, Content, Icon, Message, Dismiss } from './elements';
import HourlyIcon from 'mz-icons/hourly';
import { FormattedMessage } from 'mz-intl';
import messages from '../messages.intl';

// types
type State = {
  dismissed: boolean
};

class HourlyPricingNotice extends Component<{}, State> {
  state = { dismissed: false };

  dismissNotice = () => {
    this.setState({ dismissed: true });
  };

  render() {
    if (this.state.dismissed) return null;
    return (
      <Container>
        <Content>
          <Icon>
            <HourlyIcon />
          </Icon>
          <Message>
            <FormattedMessage message={messages.HOURLY_NOTICE} />
          </Message>
          <Dismiss onClick={this.dismissNotice}>
            <CrossIcon />
          </Dismiss>
        </Content>
      </Container>
    );
  }
}

export default HourlyPricingNotice;
